export default __webpack_public_path__ + "static/media/5.3.d1d2e944.jpg";